import { RadioGroup } from '@headlessui/react';
import { PaperAirplaneIcon } from '@heroicons/react/24/solid';
import { useCallback } from 'react';

interface Props {
  items: {
    id: number;
    name: string;
  }[];
  value: any;
  onChange: (value: any) => void;
  className?: string;
}

const CustomRadioGroup = ({ items, value, onChange, className }: Props) => {
  const getButtonClassName = useCallback((checked: boolean) => {
    const btnClassName =
      'p-3 border rounded-xl w-full flex justify-between items-center';

    if (checked) {
      return `${btnClassName} bg-backGroundGray border-white`;
    }

    return `${btnClassName} border-dividerGray`;
  }, []);

  return (
    <RadioGroup
      value={value}
      onChange={onChange}
      className={`flex flex-col gap-3 my-3 ${className || ''}`}
    >
      {items.map((s) => (
        <RadioGroup.Option key={s.id} value={s.name}>
          {({ checked }) => (
            <button type="button" className={getButtonClassName(checked)}>
              <span className="text-mainBlue text-sm">{s.name}</span>
              <span className="text-mainBlue">
                <PaperAirplaneIcon width={15} className="text-mainBlue" />
              </span>
            </button>
          )}
        </RadioGroup.Option>
      ))}
    </RadioGroup>
  );
};

export default CustomRadioGroup;
